import type { ModelDefinition } from "@/models.js";

export const bytedanceModels = [
	{
		id: "seed-1-6-250615",
		name: "Seed 1.6 (250615)",
		description:
			"ByteDance Seed 1.6 vision model with thinking/non-thinking modes, multimodal inputs, and 256K context window",
		family: "bytedance",
		releasedAt: new Date("2025-06-25"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-6-250615",
				inputPrice: "0.00025e-3",
				outputPrice: "0.002e-3",
				cachedInputPrice: "0.00005e-3",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-1-6-250915",
		name: "Seed 1.6 (250915)",
		description:
			"ByteDance Seed 1.6 vision model released September 15, 2025 with thinking/non-thinking modes and multimodal inputs",
		family: "bytedance",
		releasedAt: new Date("2025-09-15"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-6-250915",
				inputPrice: "0.00025e-3",
				cachedInputPrice: "0.00005e-3",
				outputPrice: "0.002e-3",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-1-6-flash-250715",
		name: "Seed 1.6 Flash (250715)",
		description:
			"ByteDance Seed 1.6 Flash - faster, cost-effective vision model released July 15, 2025",
		family: "bytedance",
		releasedAt: new Date("2025-07-26"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-6-flash-250715",
				inputPrice: "0.00007e-3",
				cachedInputPrice: "0.000015e-3",
				outputPrice: "0.0003e-3",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-1-8-251228",
		name: "Seed 1.8 (251228)",
		description:
			"ByteDance Seed 1.8 advanced vision model released December 28, 2025 with enhanced capabilities",
		family: "bytedance",
		releasedAt: new Date("2025-12-18"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-8-251228",
				inputPrice: "0.00025e-3",
				cachedInputPrice: "0.00005e-3",
				outputPrice: "0.002e-3",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seedream-4-0",
		name: "Seedream 4.0",
		description:
			"ByteDance Seedream 4.0 text-to-image generation model with high-quality visual output",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2025-09-16"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedream-4-0-250828",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.035",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
	{
		id: "seedance-2-0",
		name: "Seedance 2.0",
		description:
			"ByteDance Seedance 2.0 high-quality video generation model with text-to-video and image-to-video support",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-04-14"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dreamina-seedance-2-0-260128",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.1512",
					default_video: "0.1512",
					"1080p_audio": "0.3402",
					"1080p_video": "0.3402",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedance-2-0-fast",
		name: "Seedance 2.0 Fast",
		description:
			"ByteDance Seedance 2.0 Fast - accelerated video generation model for quicker outputs",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-04-14"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dreamina-seedance-2-0-fast-260128",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.121",
					default_video: "0.121",
					"1080p_audio": "0.2722",
					"1080p_video": "0.2722",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedance-1-5-pro",
		name: "Seedance 1.5 Pro",
		description:
			"ByteDance Seedance 1.5 Pro - professional video generation model with complex instruction following and native audio",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-03-23"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedance-1-5-pro-251215",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.05184",
					default_video: "0.02592",
					"1080p_audio": "0.1166",
					"1080p_video": "0.05832",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedream-4-5",
		name: "Seedream 4.5",
		description:
			"ByteDance Seedream 4.5 advanced text-to-image generation model with enhanced quality and consistency",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2025-12-03"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedream-4-5-251128",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.045",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
] as const satisfies ModelDefinition[];
